import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';


export function validCardsValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let cards = control.value;
    let error = false;
    if (!(typeof cards == "string")) {
      error = true;
    } else {
      cards = cards.split(",");
      let oldCard = undefined;
      for (let card of cards) {
        if (oldCard != undefined) {
          error = error || (+oldCard % +card != 0);
        }
        oldCard = card;
      }
      if (cards[cards.length - 1] != 1) {
        error = true;
      }
    }
    return error ? { 'appValidCards': { value: control.value } } : null;
  };
}

@Directive({
  selector: '[appValidCards]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidCardsDirective, multi: true }]

})
export class ValidCardsDirective {

  validate(control: AbstractControl): { [key: string]: any } {
    return control.value ? validCardsValidator()(control) : null;
  }

}
